import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext, useState, useEffect } from 'react';
import { AiOutlineCaretDown } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import AdminPresetsIcon from '../../public/resources/icon/navbar/icon_admin_presets.svg';
import ManageAdminIcon from '../../public/resources/icon/navbar/icon_manageadmin.svg';
import ManageGroupIcon from '../../public/resources/icon/navbar/icon_managegroups.svg';
import AllShareIcon from '../../public/resources/icon/navbar/icon_menu_allshare.svg';
import DataIcon from '../../public/resources/icon/navbar/icon_menu_data.svg';
import FibreIcon from '../../public/resources/icon/navbar/icon_menu_fibre.svg';
import MobileIcon from '../../public/resources/icon/navbar/icon_menu_mobile.svg';
import PaymentHistoryIcon from '../../public/resources/icon/navbar/icon_menu_paymentHistory.svg';
import NotifyIcon from '../../public/resources/icon/navbar/icon_menu_notification.svg';
import WirelessIcon from '../../public/resources/icon/navbar/icon_menu_wireless.svg';
import LogoutIcon from '../../public/resources/icon/navbar/profileIcon/icon_logout.svg';
import MyProfileICON from '../../public/resources/icon/navbar/profileIcon/icon_myprofile.svg';
import HistoryIcon from '../../public/resources/icon/navbar/profileIcon/icon_view_history.svg';
import CelcomLogo from '../../public/resources/logo/logo-celcom-business-reverse.svg';
import { msalInstance1 } from '../../services/msal';
import { resetState } from '../../store/Slicer/AccessSlice';
import style1 from './header.module.css';
import axios from 'axios';
import { AuthContext } from '../../Helper/authContext';
import { resetCustomerState } from '../../store/Slicer/CustomerSlicer';
import { NotificationContext } from '../../Helper/NotificationContext';
import { LogoutUserState } from '../../store/Slicer/UserSlice';
import {
  getCustBillRetrieveResPlans,
  resetCustBillState,
} from '../../store/Slicer/CustomerBillRetrieve';
import useHttp from '../../Helper/use-http';
import LoadingDailog from '../../Helper/LoadingDailog';
import { format } from 'date-fns';
import { resetPGState } from '../../store/Slicer/PGSlice';
import {
  getFetchAccountAndBillingData,
  getselectedData,
  resetAccountandbilling,
} from '../../store/Slicer/accountandBliingSlice';
import ErrorApiPopup from '../ReusableComponents/ErrorApiMessage/ErrorApiPopup';
import Badge from '../ReusableComponents/Badge/Badge';
import ErrorHandling from '../ReusableComponents/ErrorHandling/ErrorHandling';
import { convertDate } from '../../Helper/helper';
const Header = () => {
  const router = useRouter();
  const [showSubs, setShowSubs] = useState(true);
  const [showManage, setShowManages] = useState(true);
  const [showProfile, setShowProfile] = useState(true);
  const [showHamburger, setShowHamburger] = useState(false);
  const [errorAPIMessage, setErrorAPIMessage] = useState('');
  const [modalIsOpenError, setModalIsOpenError] = useState(false);

  const [state, setState] = useState({
    menu: false,
  });
  const toggleMenu = () => {
    setState({
      ...state,
      menu: !state.menu,
    });
    setShowHamburger(true);
  };

  const show = state.menu ? 'show' : '';
  const show2 = state.menu
    ? 'navbar-toggler pb-4 ml-3'
    : 'navbar-toggler collapsed pb-4 ml-3';

  const { name, email, firstName, lastName, fromADLogin } = useSelector(
    (state) => state.GetAccess?.loginUser
  );
  const { AdminAccess } = useSelector(
    (state) => state.GetAccess?.Celcompresets
  );

  const dispatch = useDispatch();

  const showHeader =
    router.pathname === '/ManageCompany' || router.pathname === '/ManageRole'
      ? true
      : false;
  const { ROLE } = useSelector((state) => state.GetAccess?.Authpresets);
  const { MobileNum } = useSelector((state) => state.GetAccess?.user);
  const { GroupName, CustID } = useSelector(
    (state) => state.GetAccess?.Authpresets
  );
  const { user } = useSelector((state) => state.user);
  const { Presets } = useSelector((state) => state.GetAccess?.Authpresets);
  const { custBillRetrieveRespForPlans, itemPerPage, pageNumber } = useSelector(
    (state) => state.accountAndBilling
  );
  const { AuthSelectedUser } = useSelector((state) => state.GetAccess?.user);
  const { AdminUser_name, AdminUser_email } = useSelector(
    (state) => state.GetAccess?.Adminuser
  );
  const { userId } = useSelector((state) => state.GetAccess?.loginUser);
  const owner = AuthSelectedUser ? AuthSelectedUser : userId;
  const { notification, removeNotification, unreadNotification } =
    useContext(NotificationContext);

  let accountAndBilling_URLs = [
    '/accountAndBilling/MobilePlans',
    '/accountAndBilling/DataPlans',
    '/accountAndBilling/CelcomAllShare',
    '/accountAndBilling/Wireless',
    '/accountAndBilling/Fibre',
    '/accountAndBilling/PaymentHistory',
  ];

  let ManageCompany_URLs = ['/manageAdmin', '/groups', '/manageAdminPresets'];

  const active = (pathName) => {
    // console.log('pathName', pathName, pathName === router.pathname);
    if (pathName === router.pathname) {
      return style1.activeNavbar;
    } else if (pathName === true) {
      return style1.activeNavbar;
    } else {
      return style1.unActiveNavbar;
    }
  };
  function getData() {
    // DashboardHistoryApiHandler();
    if (AuthSelectedUser) {
      if (Presets?.includes('View History')) {
        router.push(
          {
            pathname: '/ViewHistoryForPIC',
            query: { ID: owner, brnNo: CustID, role: ROLE },
          }
          // '/ViewHistoryForPIC'
        );
        setShowProfile(!showProfile);
      } else {
        setErrorAPIMessage(process.env.NEXT_PUBLIC_PresetsError);
        setModalIsOpenError(true);
        return;
      }
    } else {
      router.push({
        pathname: '/ViewHistory',
        query: { ID: CustID, screen: 'Manage User' },
      });
    }
  }
  function getGroupsData() {
    // DashboardHistoryApiHandler();
    router.push({
      pathname: '/groups',
      query: { brnNo: CustID },
    });
    setShowManages(!showManage);
  }
  // console.log("name:header", name)
  // console.log("CustID:header", CustID)
  // , name: name, CustID: CustID
  function getSupportData() {
    if (AdminAccess === 'Customer Care') {
      router.push({
        pathname: '/support',
        query: { tab: 2 },
      });
    } else {
      router.push({
        pathname: '/support',
        query: { tab: 1 },
      });
    }
  }
  // useEffect(() => {
  //   window.sessionStorage.setItem(
  //     "dashboardHistoryDetails",
  //     JSON.stringify(dashboardViewHistoryData)
  //   );
  // }, [dashboardViewHistoryData]);

  const logoutMethod = async () => {
    {
      CustID ? logoutDataUpdate() : getLastLoginData();
    }
    /* deleteCookie('AUTHTOKEN2');
    deleteCookie('AUTHKEY2'); */
    // dispatch(LogoutUserState());
    // dispatch(resetState());
    // dispatch(resetAccountandbilling());
    setShowProfile(!showProfile);
    window.sessionStorage.removeItem('loginType');
    window.sessionStorage.removeItem('msal.interaction.status');
    window.sessionStorage.clear();
    window.sessionStorage.removeItem('msal.interaction.status');
    // window.sessionStorage.clear();
    window.localStorage.clear();
    const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');

    for (var key in window.sessionStorage) {
      if (key.indexOf('msal') != -1) {
        window.sessionStorage.removeItem(key);
      }
    }

    msalInstance1.logoutRedirect();
  };

  // const [notification, setNotification] = useState([]);
  // useEffect(() => {
  //   if (!showHeader) {
  //     fetch(`/bizcareui/api/ManageNotification/bellNotification`)
  //       .then((results) => results.json())
  //       .then((data) => {
  //         const result = data.result;

  //         if (result === 'Failed to load data' || result?.length === 0 || result === 'No Data Found') {
  //           setNotification([]);
  //           console.log(result);
  //         } else if (result?.length > 0) {
  //           setNotification(result);
  //           console.log('Success ===>', result);
  //         } else {
  //           setNotification([]);
  //           console.log('Error to load notification.');
  //         }
  //       });
  //   }
  // }, []);

  const displayedNotifications = notification.slice(0, 5);
  const totalNotifications = notification.length;

  // const handleRemoveNotification = (id) => {
  //   setNotification((prevNotifications) =>
  //     prevNotifications.filter((notification) => notification.id !== id)
  //   );
  // };
  //const urlLink = getCookie('AUTHTOKEN');
  let brn = '';
  const getLastLoginData = async () => {
    try {
      const res = await fetch(`/bizcareui/api/getLoginHistory?user=${owner}`, {
        method: 'GET',
        headers: {
          // Authorization: Buffer.from(AuthSelectedUser).toString('base64'),
          'Content-Type': 'application/json',
        },
      });
      const data = await res.json();
      if (data?.error === process.env.NEXT_PUBLIC_RateLimitError) {
        ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
      } else {
        brn = data.result[0].CUSTOMER_ID;
        logoutDataDetailsUpdate(brn);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const logoutDataDetailsUpdate = async (brn) => {
    var payload = {
      MOBILE_NO: MobileNum,
      TRANS_TYPE: 'SIGN OUT',
      TRANS_DESCRIPTION: 'Sign out successfully',
      BRN_NUMBER: brn,
      LoginId: owner,
    };
    try {
      const res = await fetch(`/bizcareui/api/updateUserLoginHistory`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const Loginresult = await res.json();
      if (Loginresult?.result === 'Login Details Updated Successfully') {
        setShowProfile(!showProfile);
        /*   deleteCookie('AUTHTOKEN');
          deleteCookie('AUTHKEY');
          deleteCookie('AUTHTOKEN2');
          deleteCookie('AUTHKEY2'); */
        window.localStorage.clear();
        window.sessionStorage.clear();
        dispatch(LogoutUserState());
        dispatch(resetState());
        dispatch(resetAccountandbilling());
        dispatch(resetCustomerState());
        dispatch(resetPGState());
        const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');

        // router.push('/');
      } else if (
        Loginresult?.error === process.env.NEXT_PUBLIC_RateLimitError
      ) {
        ErrorHandling(Loginresult, setErrorAPIMessage, setModalIsOpenError);
      }
    } catch (error) {
      console.error(error);
      dispatch(LogoutUserState());
      dispatch(resetState());
      dispatch(resetAccountandbilling());

      dispatch(resetCustomerState());
      dispatch(resetPGState());
      const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');
    }
    dispatch(LogoutUserState());
    dispatch(resetState());
    dispatch(resetAccountandbilling());
    dispatch(resetCustomerState());
    dispatch(resetPGState());
    console.log('inside pic logout');
    router.push('/');
  };

  const logoutDataUpdate = async (brn) => {
    var payload = {
      MOBILE_NO: MobileNum,
      TRANS_TYPE: 'SIGN OUT',
      TRANS_DESCRIPTION: 'Sign out successfully',
      BRN_NUMBER: CustID,
      LoginId: owner,
    };
    try {
      const res = await fetch(`/bizcareui/api/updateUserLoginHistory`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          //Authorization: urlLink,
        },
      });
      console.log('inside pic logout 1');
      const Loginresult = await res.json();
      if (Loginresult?.result === 'Login Details Updated Successfully') {
        setShowProfile(!showProfile);
        /*  deleteCookie('AUTHTOKEN');
         deleteCookie('AUTHKEY');
         deleteCookie('AUTHTOKEN2');
         deleteCookie('AUTHKEY2'); */
        dispatch(LogoutUserState());
        dispatch(resetState());
        dispatch(resetAccountandbilling());
        dispatch(resetCustomerState());
        dispatch(resetPGState());
        window.sessionStorage.clear();
        window.localStorage.clear();
        const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');
        // dispatch(LogoutUserState());
        // dispatch(resetState());
        // dispatch(resetAccountandbilling());

        // dispatch(resetCustomerState());
        // dispatch(resetCustBillState());
        // dispatch(resetPGState());

        //  router.push('/');
      } else if (
        Loginresult?.error === process.env.NEXT_PUBLIC_RateLimitError
      ) {
        ErrorHandling(Loginresult, setErrorAPIMessage, setModalIsOpenError);
      }
    } catch (error) {
      console.error(error);
      window.sessionStorage.clear();
      window.localStorage.clear();
      const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');
      // dispatch(LogoutUserState());
      // dispatch(resetState());
      // dispatch(resetAccountandbilling());
      // dispatch(resetCustomerState());
      // dispatch(resetCustBillState());
      // dispatch(resetPGState());

      // router.push('/');
    }
    dispatch(LogoutUserState());
    dispatch(resetState());
    dispatch(resetAccountandbilling());
    dispatch(resetCustomerState());
    dispatch(resetPGState());
    console.log('before routing');
    router.push('/');
  };
  const {
    isLoading: loading,
    error,
    sendRequest: sendFetchOrgCustomerAccountDetailsRequest,
  } = useHttp();
  const clickHandler = (name, event) => {
    event.preventDefault();
    if (name == 'CelcomAllShare') {
      router.push('/accountAndBilling/CelcomAllShare');
    } else if (name == 'MobilePlans') {
      router.push('/accountAndBilling/MobilePlans');
    } else if (name == 'DataPlans') {
      router.push('/accountAndBilling/DataPlans');
    } else if (name == 'Fibre') {
      router.push('/accountAndBilling/Fibre');
    } else if (name == 'Wireless') {
      router.push('/accountAndBilling/Wireless');
    }
  };
  let serviceTypes = '';
  const fetchOrgCustomerAccountDetails = async (name, event) => {
    if (name == 'All Share') {
      serviceTypes = 2;
      router.push('/accountAndBilling/CelcomAllShare');
    } else if (name == 'Mobile') {
      serviceTypes = 1;
      router.push('/accountAndBilling/MobilePlans');
    } else if (name == 'Data') {
      serviceTypes = 9;
      router.push('/accountAndBilling/DataPlans');
    } else if (name == 'Fibre') {
      serviceTypes = 5;
      router.push('/accountAndBilling/Fibre');
    } else if (name == 'Wireless') {
      serviceTypes = 7;
      router.push('/accountAndBilling/Wireless');
    }else if(name == 'Payment History'){
      router.push('/accountAndBilling/PaymentHistory');
    }

    // dispatch(
    //   getFetchAccountAndBillingData(
    //     1,
    //     5,
    //     GroupName,
    //     serviceTypes,
    //     CustID,
    //     name,
    //     router,
    //     'Active',
    //   )
    // );
  };

  // const convertDate = (date) => {
  //   return format(
  //     new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kuala_Lumpur' })),
  //     'yyyy-MM-dd'
  //   );
  // };

  const inManageNoti =
    window.location.pathname === '/bizcareui/ManageNotifications';

  return (
    <>
      <LoadingDailog isLoading={custBillRetrieveRespForPlans?.loading} />
      <ErrorApiPopup
        modalIsOpenError={
          custBillRetrieveRespForPlans?.modalIsOpenError || modalIsOpenError
        }
        errorAPIMessage={custBillRetrieveRespForPlans?.error || errorAPIMessage}
        clickOKHandler={() => {
          dispatch(
            getselectedData({
              data: [],
              loading: false,
              error: '',
              modalIsOpenError: false,
            })
          );
          if (errorAPIMessage === process.env.NEXT_PUBLIC_RateLimitError) {
            setModalIsOpenError(false);
          }
        }}
      />
      {user === null || user === '' ? (
        ''
      ) : (
        <header className={style1.mobileContainer}>
          <nav
            className={`navbar navbar-expand-lg navbar-dark  fixed-top w-100  ${style1.navColor}`}
          >
            <div className={`container ${style1.navbarHeight}`}>
              {showHeader && (
                <Link href="">
                  <a
                    className={`navbar-brand order-lg-1 ${style1.CelcomLogo}`}
                    // className="navbar-brand order-lg-1"
                    style={{ cursor: 'default' }}
                  >
                    <CelcomLogo />
                  </a>
                </Link>
              )}
              {!showHeader && (
                <Link href="/DashBoardView">
                  <a className={`navbar-brand order-lg-1 ${style1.CelcomLogo}`}>
                    {/* // className="navbar-brand order-lg-1"> */}
                    <CelcomLogo />
                  </a>
                </Link>
              )}
              <div className="d-lg-flex flex-lg-wrap flex-lg-column align-items-lg-end order-lg-3">
                <ul className="navbar-global collapse collapse-dark"></ul>

                <ul className="navbar-icon" style={{ marginTop: 30 }}>
                  {!showHeader && (
                    <li
                      className="nav-item d-lg-block"
                      style={{ marginBottom: '21px' }}
                    >
                      <div
                        className={`${style1.profileBody} ${style1.bellIcon} ${
                          inManageNoti && style1.viewAllNotificationPIC
                        }`}
                      >
                        <button className={style1.profileChild}>
                          <NotifyIcon />
                          {unreadNotification > 0 && (
                            <Badge count={unreadNotification} />
                          )}
                        </button>
                        <div
                          className={`rounded-bottom ${style1.profileContent} ${style1.widthNotiBox}`}
                        >
                          <div className={style1.notiBox}>
                            <div
                              className={`d-flex flex-row justify-content-between ${style1.notiHeading}`}
                            >
                              <h6 className="mb-0 cursor-default">
                                <span className="font-weight-bold">
                                  Notifications
                                </span>{' '}
                                &#40;{totalNotifications}&#41;
                              </h6>
                              <Link
                                href={{
                                  pathname: '/ManageNotifications',
                                  query: { id: user.role },
                                }}
                              >
                                <a
                                  className={`p-0 text-primary my-auto bg-transparent ${style1.font}`}
                                >
                                  View All
                                </a>
                              </Link>
                            </div>

                            <div>
                              {displayedNotifications?.length === 0 ? (
                                <div className="noRecord">No notification</div>
                              ) : (
                                displayedNotifications?.map((data, index) => {
                                  return (
                                    <div
                                      key={index}
                                      id="noti"
                                      className={style1.notiDropdown}
                                    >
                                      {data.notiShow}
                                      <div
                                        className={`${style1.update} d-flex flex-row justify-content-between`}
                                      >
                                        <div className="font-weight-bold cursor-default">
                                          {data.updates}
                                        </div>
                                        <div
                                          className={style1.closeBtn}
                                          data-dismiss="modal"
                                          aria-label="Close"
                                          onClick={() => {
                                            removeNotification(data.id);
                                          }}
                                        >
                                          <span className="invisible">
                                            close
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className={`${style1.desc} cursor-default`}
                                      >
                                        {data.Description}
                                      </div>
                                      <div
                                        className={`cursor-default d-flex flex-row ${style1.date}`}
                                      >
                                        <div
                                          className={`w-50 ${style1.borderStart}`}
                                        >
                                          <span>Start:&nbsp;</span>
                                          {/* {data.dateStart.slice(0, 10)} */}
                                          {convertDate(data.dateStart)}
                                        </div>
                                        <div className="w-50 text-center">
                                          <span>End:&nbsp;</span>
                                          {/* {data.dateEnd.slice(0, 10)} */}
                                          {convertDate(data.dateEnd)}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              )}
                            </div>
                          </div>
                        </div>
                        {/* } */}
                      </div>
                    </li>
                  )}
                  {showHeader && (
                    <li
                      className="nav-item ml-4"
                      onMouseOver={() => setShowProfile(true)}
                      onMouseLeave={() => setShowProfile(false)}
                      style={{ marginBottom: '18px' }}
                    >
                      <div className={style1.profileBody}>
                        <div className="mt-n3  text-center">
                          <button className={style1.profileChild}>
                            {/* <div className="d-flex">
                            <div
                              className={`rounded-circle bg-white text-black mr-1 p-1 px-2 text-bold ${style1.profileName}`}
                            >
                              JS
                            </div>
                            <div className="text-center mt-1">
                              {AuthSelectedUser}
                            </div>
                          </div> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28.012"
                              height="28.001"
                              viewBox="0 0 28.012 28.001"
                            >
                              <path
                                id="User"
                                d="M28.009,13.173v1.641c-.017.1-.037.192-.05.29-.066.506-.105,1.016-.2,1.515a13.674,13.674,0,0,1-3.795,7.214,13.657,13.657,0,0,1-7.544,3.949c-.527.091-1.062.145-1.593.216H13.186c-.079-.016-.159-.035-.239-.047-.764-.119-1.54-.182-2.289-.362A14.015,14.015,0,0,1,.25,11.377,13.609,13.609,0,0,1,4.518,3.709,13.68,13.68,0,0,1,15.936.129a13.37,13.37,0,0,1,7.292,3.332,13.71,13.71,0,0,1,4.567,8.123c.092.526.145,1.059.215,1.589ZM23.344,22.04A12.34,12.34,0,1,0,4.481,6.127a12.245,12.245,0,0,0,.195,15.892,9.719,9.719,0,0,1,6.008-6.659A5.9,5.9,0,1,1,17.86,6.027a5.714,5.714,0,0,1,2.028,4.293,5.857,5.857,0,0,1-2.558,5.034,9.758,9.758,0,0,1,6.014,6.685Zm-9.112,4.318c.3-.025.823-.05,1.347-.115A12.008,12.008,0,0,0,21.3,23.959c.691-.508.682-.521.475-1.377a7.97,7.97,0,0,0-15.656.739.345.345,0,0,0,.116.262,12.484,12.484,0,0,0,8,2.776Zm-.227-11.63a4.251,4.251,0,1,0-4.253-4.237,4.264,4.264,0,0,0,4.253,4.237Z"
                                transform="translate(0.002 0.003)"
                                fill="#fff"
                              />
                            </svg>
                          </button>
                        </div>

                        {showProfile && (
                          <div
                            className={`rounded-bottom ${style1.profileContent}`}
                          >
                            <div className="" style={{ padding: 10 }}>
                              <h6 className="font-weight-bold mb-0 pt-2 pl-2 pb-1">
                                {/* My Account */}
                                {firstName} {lastName}
                              </h6>
                              <h6 className="font-weight-bold mb-0 pt-1 pl-2 pb-1">
                                {/* My Account */}
                                {name}
                              </h6>
                              <span
                                style={{ marginLeft: 10, color: '#009bdf' }}
                              >
                                {/* email.com */}
                                {email}
                              </span>
                              {/* <div className="dropdown-divider my-1"></div>
                            <Link href="#">
                              <a
                                className="dropdown-item"
                                onClick={() => setShowProfile(!showProfile)}
                              >
                                <ChangePasswordIcon className="mr-2" />
                                Change Password
                              </a>
                            </Link> */}
                              <div className="dropdown-divider my-1"></div>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  getLastLoginData();
                                  if (user.role === 'Admin') {
                                    logoutMethod();
                                  }
                                }}
                              >
                                <LogoutIcon className="mr-2" />
                                Logout
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  )}
                  {!showHeader && (
                    <>
                      <li
                        className="nav-item ml-4"
                        onMouseOver={() => setShowProfile(true)}
                        onMouseLeave={() => setShowProfile(false)}
                        style={{ marginBottom: '19px' }}
                      >
                        <div className={style1.profileBody}>
                          <div className="mt-n3  text-center profile">
                            <button className={style1.profileChild}>
                              {/* <div className="d-flex">
                            <div
                              className={`rounded-circle bg-white text-black mr-1 p-1 px-2 text-bold ${style1.profileName}`}
                            >
                              JS
                            </div>
                            <div className="text-center mt-1">
                              {AuthSelectedUser}
                            </div>
                          </div> */}

                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28.012"
                                height="28.001"
                                viewBox="0 0 28.012 28.001"
                              >
                                <path
                                  id="User"
                                  d="M28.009,13.173v1.641c-.017.1-.037.192-.05.29-.066.506-.105,1.016-.2,1.515a13.674,13.674,0,0,1-3.795,7.214,13.657,13.657,0,0,1-7.544,3.949c-.527.091-1.062.145-1.593.216H13.186c-.079-.016-.159-.035-.239-.047-.764-.119-1.54-.182-2.289-.362A14.015,14.015,0,0,1,.25,11.377,13.609,13.609,0,0,1,4.518,3.709,13.68,13.68,0,0,1,15.936.129a13.37,13.37,0,0,1,7.292,3.332,13.71,13.71,0,0,1,4.567,8.123c.092.526.145,1.059.215,1.589ZM23.344,22.04A12.34,12.34,0,1,0,4.481,6.127a12.245,12.245,0,0,0,.195,15.892,9.719,9.719,0,0,1,6.008-6.659A5.9,5.9,0,1,1,17.86,6.027a5.714,5.714,0,0,1,2.028,4.293,5.857,5.857,0,0,1-2.558,5.034,9.758,9.758,0,0,1,6.014,6.685Zm-9.112,4.318c.3-.025.823-.05,1.347-.115A12.008,12.008,0,0,0,21.3,23.959c.691-.508.682-.521.475-1.377a7.97,7.97,0,0,0-15.656.739.345.345,0,0,0,.116.262,12.484,12.484,0,0,0,8,2.776Zm-.227-11.63a4.251,4.251,0,1,0-4.253-4.237,4.264,4.264,0,0,0,4.253,4.237Z"
                                  transform="translate(0.002 0.003)"
                                  fill="#fff"
                                />
                              </svg>
                            </button>
                          </div>

                          {showProfile && (
                            <div
                              className={`rounded-bottom ${style1.profileContent}`}
                            >
                              <div className="" style={{ padding: 10 }}>
                                <h6 className="font-weight-bold mb-0 pt-2 pl-2 pb-1">
                                  {/* My Account */}
                                  {firstName} {lastName}
                                </h6>
                                <h6 className="font-weight-bold mb-0 pt-1 pl-2 pb-1">
                                  {/* My Account */}
                                  {name}
                                </h6>
                                <span
                                  style={{ marginLeft: 10, color: '#009bdf' }}
                                >
                                  {/* email.com */}
                                  {email}
                                </span>
                                <div
                                  className="dropdown-divider my-1"
                                  style={{ margin: '0px 7px 0px 7px' }}
                                ></div>
                                {/* <div className="d-flex">
                                <Link href="#">
                                  <a
                                    className="dropdown-item"
                                    onClick={() => setShowProfile(!showProfile)}
                                  >
                                    <ManagePICICON className="mr-2" />
                                    Manage PIC
                                  </a>
                                </Link>
                              </div> */}
                                {/* <Link href={{ pathname: "/ViewHistoryForPIC" }}> */}
                                <a
                                  className="dropdown-item"
                                  onClick={() => getData()}
                                >
                                  <HistoryIcon
                                    className="mr-2"
                                    style={{ color: 'blue' }}
                                  />
                                  View History
                                </a>
                                {/* </Link> */}
                                <Link href="/MyProfile">
                                  <a
                                    className="dropdown-item"
                                    onClick={() => setShowProfile(!showProfile)}
                                  >
                                    <MyProfileICON className="mr-2" />
                                    My Profile
                                  </a>
                                </Link>
                                <div className="dropdown-divider my-1"></div>
                                <a
                                  className="dropdown-item"
                                  onClick={() => {
                                    logoutDataUpdate();
                                    if (user.role === 'Admin') {
                                      logoutMethod();
                                    }
                                  }}
                                >
                                  <LogoutIcon className="mr-2" />
                                  Logout
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      </li>
                      <button
                        className={show2}
                        type="button"
                        onClick={() => {
                          toggleMenu();
                        }}
                        // style={{ marginLeft: 15 }}
                      >
                        <span className="navbar-toggler-icon"></span>
                      </button>
                    </>
                  )}
                </ul>
              </div>
              {!showHeader && (
                <div
                  className={`collapse navbar-collapse ${show} collapse-dark order-lg-2  ${style1.hamburger}`}
                >
                  <ul className={`navbar-tab ${style1.hamburgerUL}`}>
                    {fromADLogin && (
                      <li
                        className={`nav-item ${active('#')}`}
                        onClick={() => {
                          toggleMenu();
                        }}
                      >
                        <Link href="/Celcom_dashboard">
                          <a
                            className={`nav-link ${style1.dashboard}  ${style1.support}`}
                          >
                            Celcom Admin
                          </a>
                        </Link>
                      </li>
                    )}
                    <li
                      className={`nav-item ${active('/DashBoardView')}`}
                      onClick={() => {
                        toggleMenu();
                      }}
                    >
                      <Link href="/DashBoardView">
                        <a
                          className={`nav-link ${style1.dashboard}  ${style1.support}`}
                        >
                          Dashboard
                        </a>
                      </Link>
                    </li>
                    <li
                      className={`nav-item ${active(
                        accountAndBilling_URLs.includes(router.asPath)
                      )} ${style1.AccntBilling}`}
                      onMouseOver={() => setShowSubs(true)}
                      onMouseLeave={() => setShowSubs(false)}
                    >
                      <div className={style1.dropdownManage}>
                        <button
                          className={`${style1.dropbtnManage} ${style1.dashboard}`}
                        >
                          <span>Accounts & Billing </span>
                          <br />
                          <AiOutlineCaretDown />
                        </button>
                        {showSubs && (
                          <div
                            style={{ height: 250 }}
                            className={`rounded-bottom  ${style1.dropdownContentManage}`}
                          >
                            <div className="mb-2 mx-1 mt-1">
                              <div className="d-flex p-0 ">
                                {/* <Link href="/accountAndBilling/MobilePlans"> */}
                                <a
                                  className="dropdown-item"
                                  onClick={(e) => {
                                    if (showHamburger) {
                                      toggleMenu();
                                    }
                                    dispatch(resetAccountandbilling());
                                    fetchOrgCustomerAccountDetails('Mobile', e);
                                  }}
                                >
                                  <MobileIcon className="mr-2" />
                                  Mobile
                                </a>
                                {/* </Link> */}
                              </div>
                              <a
                                className="dropdown-item"
                                onClick={(e) => {
                                  if (showHamburger) {
                                    toggleMenu();
                                  }
                                  dispatch(resetAccountandbilling());
                                  fetchOrgCustomerAccountDetails('Data', e);
                                }}
                              >
                                <DataIcon className="mr-2" />
                                Data
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={(e) => {
                                  if (showHamburger) {
                                    toggleMenu();
                                  }
                                  dispatch(resetAccountandbilling());
                                  fetchOrgCustomerAccountDetails(
                                    'All Share',
                                    e
                                  );
                                }}
                              >
                                <AllShareIcon className="mr-2" />
                                Celcom Business AllShare
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={(e) => {
                                  if (showHamburger) {
                                    toggleMenu();
                                  }
                                  dispatch(resetAccountandbilling());
                                  fetchOrgCustomerAccountDetails('Wireless', e);
                                }}
                              >
                                <WirelessIcon className="mr-2" />
                                Celcom Business Wireless
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={(e) => {
                                  if (showHamburger) {
                                    toggleMenu();
                                  }
                                  dispatch(resetAccountandbilling());
                                  fetchOrgCustomerAccountDetails('Fibre', e);
                                }}
                              >
                                <FibreIcon className="mr-2" />
                                Celcom Business Fibre
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={(e) => {
                                  if (showHamburger) {
                                    toggleMenu();
                                  }
                                  dispatch(resetAccountandbilling());
                                  fetchOrgCustomerAccountDetails('Payment History', e);
                                }}
                              >
                                <PaymentHistoryIcon className="mr-2" />
                                Payment History
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                    {ROLE === 'Super Admin' && (
                      <li
                        className={`nav-item ${active(
                          ManageCompany_URLs.includes(router.pathname)
                        )} ${style1.AccntBilling}`}
                        onMouseOver={() => setShowManages(true)}
                        onMouseLeave={() => setShowManages(false)}
                      >
                        <div className={style1.dropdownManage}>
                          <button className={style1.dropbtnManage}>
                            Manage Company
                            <br />
                            <AiOutlineCaretDown />
                          </button>
                          {showManage && (
                            <div
                              className={`rounded-bottom  ${style1.dropdownContentManage}`}
                            >
                              <div className="mb-2 mx-1 mt-1">
                                <div className="d-flex"></div>

                                <Link href="/manageAdmin">
                                  <a
                                    className="dropdown-item"
                                    onClick={() => {
                                      if (showHamburger) {
                                        toggleMenu();
                                      }
                                      setShowManages(!showManage);
                                    }}
                                  >
                                    <ManageAdminIcon className="mr-2" />
                                    Manage Admins
                                  </a>
                                </Link>
                                <Link href="/groups">
                                  <a
                                    className="dropdown-item"
                                    onClick={() => {
                                      if (showHamburger) {
                                        toggleMenu();
                                      }
                                      getGroupsData();
                                    }}
                                  >
                                    <ManageGroupIcon className="mr-2" />
                                    Manage Groups
                                  </a>
                                </Link>
                                <Link href="/manageAdminPresets">
                                  <a
                                    className="dropdown-item"
                                    onClick={() => {
                                      if (showHamburger) {
                                        toggleMenu();
                                      }
                                      setShowManages(!showManage);
                                    }}
                                  >
                                    <AdminPresetsIcon className="mr-2" />
                                    Manage Admin Presets
                                  </a>
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </li>
                    )}
                    <li
                      className={`nav-item  ${active('/support')}`}
                      onClick={() => {
                        toggleMenu();
                      }}
                    >
                      <div>
                        {/* onClick={() => { getSupportData() }} */}
                        {/* <Link href="/support"> */}
                        <a
                          onClick={() => {
                            getSupportData();
                          }}
                          className={`nav-link ${style1.dashboard} ${style1.support} `}
                        >
                          &nbsp;Support&nbsp;
                        </a>
                        {/* </Link> */}
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </nav>
        </header>
      )}
    </>
  );
};

export default Header;
